import { HeroSectionType } from "../features/hero";
import BasicHero from "../shared/hero/basic-hero";
interface GuidesHeroProps {
  data: HeroSectionType;
}

export function GuidesHero({ data }: GuidesHeroProps) {
 return <BasicHero data={data} />;
}
